var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxShirtSport = function Svg18PxShirtSport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.25 12.25v-4s-.458.806-1.431.992"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.151 7a47 47 0 0 0 .099 9.25h-8.5A47 47 0 0 0 4.849 7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.25 8.75 17 8l-1.605-3.813a2 2 0 0 0-1.384-1.171l-2.263-.533q.002.015.003.028a2.75 2.75 0 1 1-5.5 0q.001-.014.003-.028l-2.263.533a2 2 0 0 0-1.384 1.171L1.002 8l1.75.75"
  })));
};
export default Svg18PxShirtSport;